import { useTranslation } from "react-i18next";
import { MapPin, MousePointerClick } from "lucide-react";
import { Button } from "components/common/Button";

interface CreationModeActionBarProps {
  isMultiAddModeEnabled: boolean;
  onToggleMultiAddMode: () => void;
  isEditingElement: boolean;
  onToggleEditMode: () => void;
}

export const CreationModeActionBar = ({
  isMultiAddModeEnabled,
  onToggleMultiAddMode,
  isEditingElement,
  onToggleEditMode,
}: CreationModeActionBarProps) => {
  const { t } = useTranslation();

  return (
    <div className="mt-3 w-full flex items-center gap-2">
      <Button
        variant={isMultiAddModeEnabled ? "primary" : "outline"}
        size="sm"
        onClick={onToggleMultiAddMode}
        startAdornment={<MousePointerClick className="w-3.5 h-3.5" />}
      >
        {isMultiAddModeEnabled
          ? t("smartSurveyor.elementsCreation.multiAddOn")
          : t("smartSurveyor.elementsCreation.multiAddOff")}
      </Button>
      <Button
        variant={isEditingElement ? "primary" : "outline"}
        size="sm"
        onClick={onToggleEditMode}
        startAdornment={<MapPin className="w-3.5 h-3.5" />}
      >
        {isEditingElement
          ? t("smartSurveyor.elementsCreation.editModeOn")
          : t("smartSurveyor.elementsCreation.editMode")}
      </Button>
    </div>
  );
};
